<template>
    <main-banner
        :title="$t('games.killer_banner_title')"
        players="2 - 4"
        :difficulty="$t('game_difficulty.beginner')"
        :image="imageSrc"
        id="killer"
        @start-game="selectMatch('Killer')"
        :coming-soon="false"
    />
</template>

<script>
import MainBanner from './Main.vue'
import img from '@images/games/killer/_banner.png?src'
import { mapStores } from 'pinia'
import { useMatchStore } from '@/stores/match.js'
import { useAuthStore } from '@/stores/auth.js'

export default {
    components: {
        MainBanner,
    },
    props: {
        online: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useMatchStore, useAuthStore),
        imageSrc() {
            return img
        },
    },
    methods: {
        async selectMatch(type) {
            await this.matchStore.selectMatchType(
                type,
                this.authStore,
                this.$router,
                this.$toast,
                this.online,
            )
        },
    },
}
</script>
